<script setup lang="ts">
import type { PrimitiveProps } from 'radix-vue'
import { Primitive } from 'radix-vue'
import type { HTMLAttributes } from 'vue'

import { cn } from '@/utils'

const props = defineProps<
  PrimitiveProps & {
    class?: HTMLAttributes['class']
  }
>()
</script>

<template>
  <Primitive
    data-sidebar="group-label"
    :as="props.as"
    :as-child="props.asChild"
    :class="
      cn(
        'text-muted-foreground ring-sidebar-ring flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium outline-hidden transition-[margin,opa] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0',
        'group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0',
        props.class
      )
    "
  >
    <slot />
  </Primitive>
</template>
